import { ref } from 'vue'
import { contactsService, quotesService } from '../../services'

/**
 * Sociétés du même groupe qu'un client, chargées à la demande.
 *
 * Le rapprochement balaie la base professionnelle : on ne le déclenche
 * donc qu'à l'ouverture de la section, pas au chargement de la page. Les
 * références du même métier, elles, se cherchent par l'IA sur un bouton
 * (useSimilarCompaniesAi).
 */
export function useLinkedCompanies() {
  const sameGroup = ref([])
  const reference = ref(null)
  const loading = ref(false)
  const loaded = ref(false)

  const load = async (fetcher) => {
    if (loaded.value || loading.value) return

    loading.value = true
    try {
      const result = await fetcher()
      sameGroup.value = result?.same_group || []
      reference.value = result?.reference || null
      loaded.value = true
    } catch (error) {
      console.error('Erreur lors du chargement des sociétés liées:', error)
      sameGroup.value = []
    } finally {
      loading.value = false
    }
  }

  const loadForContact = (email, siret) => load(() => contactsService.getLinkedCompanies(email, siret))
  const loadForQuote = (quoteId) => load(() => quotesService.getLinkedCompanies(quoteId))

  return { sameGroup, reference, loading, loaded, loadForContact, loadForQuote }
}
